export const TRANSITION_RECORD_TO_STATE = 'transition-record-to-validated'